import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getEmployee, getEmployeeDetails } from '../../../network/employee';
import { getAdditionalSalayDetails } from '../../../network/additionalSalay';
import { submitMaterialRequest } from '../../../network/materialRequest';
import {
  addAttandence,
  getAttandenceDetails,
  updateAttandence,
} from '../../../network/attandence';
import { getSearchPatients } from '../../../network/appointment';
import HeadingApp from '../../../hooks/HeadingApp';
import { MdSpeakerNotes } from 'react-icons/md';
const AddAttandence = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [searchTextItems, setSearchTextItems] = useState('');
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const { mutate: onAddAdditionalSalay } = useMutation({
    mutationKey: ['addAdditionalSalay'],
    mutationFn: (body) =>
      edit ? updateAttandence(body, id) : addAttandence(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({ queryKey: [queryKeys.getAttandence] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/attandence');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Attendance', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getAttandence] });
      navigate('/attandence');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: additionalSalayDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getAttandenceDetails, id],
    queryFn: () => getAttandenceDetails(id),
    enabled: !!edit,
  });
  const { mutate: onGetEmployee } = useMutation({
    mutationKey: [queryKeys.getEmployeeDetails],
    mutationFn: (value) => getEmployeeDetails(value),
    onSuccess: (data) => {
      console.log(data, 'data');
      form.setFieldsValue({
        employee_name: data?.data?.employee_name,
        department: data?.data?.department,
      });
    },
  });
  // const { data: employeeData } = useQuery({
  //   queryKey: [queryKeys.getEmployee],
  //   queryFn: () => getEmployee(),
  // });
  const { data: employeeList } = useQuery({
    queryKey: [queryKeys.getSearchPatientsEmployee, searchTextItems],
    queryFn: () => getSearchPatients('Employee', searchTextItems),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAdditionalSalay({
      ...values,
      company: companyName,
      attendance_date: dayjs(values?.attendance_date).format('YYYY-MM-DD'),
      late_entry: values?.late_entry ? 1 : 0,
      early_exit: values?.early_exit ? 1 : 0,
    });
  };
  useEffect(() => {
    if (edit && additionalSalayDetails) {
      setDataStatus(additionalSalayDetails?.data?.docstatus);
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        attendance_date: dayjs(additionalSalayDetails?.data?.attendance_date),
      });
    }
  }, [edit, additionalSalayDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditAttandence : t.AddAttandence}
        path="/attandence"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.Attandence}
        subTitle={edit ? t.EditAttandence : t.AddAttandence}
        icon={<MdSpeakerNotes />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-attandence"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        onGetEmployee(value);
                        // form.setFieldsValue({
                        //   employee_name: option?.option?.employee_name,
                        //   department: option?.option?.department,
                        // });
                      }}
                      onSearch={(value) => {
                        setSearchTextItems(value);
                      }}
                      options={employeeList?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                        option: user,
                      }))}
                      // options={employeeData?.data?.map((user) => ({
                      //   value: user.name,
                      //   label: user.name,
                      //   option: user,
                      // }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="attendance_date"
                    label={t.attendanceDate}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.attendanceDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                      disabledDate={(current) =>
                        current && current > dayjs().endOf('day')
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="status"
                    label={t.status}
                    initialValue={''}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.status}
                      popupMatchSelectWidth={false}
                      options={[
                        {
                          value: '',
                          label: '',
                        },
                        {
                          value: 'Present',
                          label: t.Present,
                        },
                        {
                          value: 'Absent',
                          label: t.Absent,
                        },
                        {
                          value: 'On Leave',
                          label: 'On Leave',
                        },
                        {
                          value: 'Half Day',
                          label: t.HalfDay,
                        },
                        {
                          value: 'Work From Home',
                          label: t.WorkFromHome,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Form.Item
                    name="early_exit"
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.earlyExit}</Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Form.Item
                    name="late_entry"
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.lateEntry}</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddAttandence;
